import { Layout, Tag, Tooltip } from 'antd';
import { useStoreState } from '../../store';
import { useLayoutStyles } from '../styles';
import { AccountDropDown } from '../components/AccountDropdown';
import { LocaleDropdown } from '../components/LocaleDropdown';
import { SearchBar } from '../components/SearchBar';
import { Translate } from './Translate';
import { BaseFeatureToggles } from '../../store/navigation/BaseFeatureToggles';
import { useSession } from '~/hooks/useSession';

const { Header } = Layout;

export const HeaderBar = ({ children }: { children: React.ReactNode }) => {
  const classes = useLayoutStyles();
  const { isShipiumView } = useSession();
  const checkFeatureToggle = useStoreState((state) => state.partner.checkFeatureToggle);
  const localizeConsole = checkFeatureToggle(BaseFeatureToggles.LOCALIZE_CONSOLE);

  return (
    <Header className={classes.header}>
      {children}
      <div className={classes.headerActions}>
        <SearchBar />
        <AccountDropDown />
        {isShipiumView && (
          <Tooltip title="You are logged in as a Shipium administrator. Options may vary based on your authenticated role. Please exercise caution when performing actions.">
            <Tag color="cyan">Shipium Admin</Tag>
          </Tooltip>
        )}
        {!localizeConsole && <LocaleDropdown />}
        {localizeConsole && <Translate />}
      </div>
    </Header>
  );
};
